module.exports = __webpack_public_path__ + "img/4.dffd4472.png";